import { useTranslate } from "ra-core";
import { Badge } from "@/components/ui/badge";

import type { LeadStatus } from "../types";

const classes: Record<LeadStatus, string> = {
  neu: "border-blue-400 text-blue-700 dark:text-blue-300",
  uebernommen: "border-amber-400 text-amber-700 dark:text-amber-300",
  erreicht: "border-teal-400 text-teal-700 dark:text-teal-300",
  termin: "border-violet-400 text-violet-700 dark:text-violet-300",
  abschluss: "border-green-500 text-green-700 dark:text-green-300",
  verloren: "border-muted-foreground text-muted-foreground",
};

export const LeadStatusBadge = ({ status }: { status: LeadStatus }) => {
  const translate = useTranslate();
  return (
    <Badge variant="outline" className={classes[status]}>
      {translate(`resources.leads.status.${status}`)}
    </Badge>
  );
};
